<p-tabs
  appTabsUnsavedReveal
  [value]="activeTabIndex()"
  (valueChange)="onTabChange($event!)"
  [lazy]="false"
>
  <p-tablist>
    <p-tab [value]="0" [appTabStatus]="tabStatus()">
      {{ 'provider.tenderWizard.rfq.projectParameters' | transloco }}
    </p-tab>
    <p-tab [value]="1" [appTabStatus]="tabStatus()">
      {{ 'provider.tenderWizard.rfq.guidance' | transloco }}
    </p-tab>
    <p-tab [value]="2" [appTabStatus]="tabStatus()">
      {{ 'provider.tenderWizard.rfq.systemIntegration' | transloco }}
    </p-tab>
  </p-tablist>

  <p-tabpanels class="mt-6">
    <p-card>
      <p-tabpanel [value]="0">
        <app-tender-project-rfq-proposal-parameters [tenderDetails]="tenderDetails()" />
      </p-tabpanel>

      <p-tabpanel [value]="1">
        <app-tender-project-rfq-guidance [tenderDetails]="tenderDetails()" />
      </p-tabpanel>

      <p-tabpanel [value]="2">
        <app-tender-project-rfq-proposal-system-integration [tenderDetails]="tenderDetails()" />
      </p-tabpanel>
    </p-card>
  </p-tabpanels>
</p-tabs>
